import { AuditAction, AuditModule } from '../enums/audit-trail.enum';
import { ICompany } from './company.interface';
import { ICredential } from './credential.interface';

export interface IAuditTrail {
  id: number;
  uuid: string;
  createdAt?: Date;
  createdBy: number;
  endpoint: string;
  method: string;
  ip: string;
  username: string;
  moduleName: string;
  entityName: string;
  entityId: string;
  action: string;
  changes: any;
  user: UserInterface;
  oldValues: any,
  newValues: any,
  fieldsHide: string[],
}
export interface UserInterface {
  id: number;
  email: string;
  status: string;
  isActive: boolean;
  name: string;
  username: string;
  lastCredentialChange: Date;
  companies?: ICompany[];
  credential?: ICredential;
}

export interface IAuditTrailComparison {
  field: string,
  key: string,
  isChanged: boolean,
  oldValue: any,
  newValue: any,
  isArray: boolean,
  type?: string;
  isHide: boolean;
  isImage: boolean;
  oldStringHtml: string;
  newStringHtml: string;
}

export interface IAuditTrailDetail {
  moduleName: string;
  entityName: string;
  fullKey: string;
  key: string;
  type?: string;
  value: any;
}

/** Declares that a top-level array field on this record type must be matched old-item-to-new-item by `key` (instead of by index) before diffing, so reordering doesn't show as a false change. */
export interface IAuditTrailAlignField {
  fieldName: string;
  key: string;
  typeKey?: 'string' | 'number' | 'object';
}
